var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#627EEA;}\n\t.st1{fill:#FFFFFF;fill-opacity:0.602;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#FFFFFF;fill-opacity:0.2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1250,
    cy: 1250,
    r: 1250
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1288.91,312.5v692.97l585.7,261.72L1288.91,312.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1288.91,312.5l-585.78,954.69l585.78-261.72L1288.91,312.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1288.91,1716.25v470.86L1875,1376.25L1288.91,1716.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1288.91,2187.11v-470.94l-585.78-339.92L1288.91,2187.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1288.91,1607.27l585.7-340.08l-585.7-261.56V1607.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M703.12,1267.19l585.78,340.08v-601.64L703.12,1267.19z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.831f7ae9e55bbbc28ee3e16165ac906c.svg";
export { ForwardRef as ReactComponent };